import { releaseAnnouncementActionTypes as actionTypes } from '../ActionTypes/releaseAnnouncementActionTypes';
import { apiThunk } from '../Utils/apiThunk';
import type { ActiveAnnouncement } from '../Components/Announcement/Announcement.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;

const LOADING_KEY = 'releaseAnnouncement';

const storeActiveAnnouncement = (dispatch: AnyDispatch) => (data: ActiveAnnouncement | null) => {
    if (data) dispatch({ type: actionTypes.STORE_ACTIVE_ANNOUNCEMENT, data });
};

const releaseAnnouncementActions = {
    getActiveAnnouncement() {
        return (dispatch: AnyDispatch) =>
            dispatch(apiThunk<ActiveAnnouncement>('/api/releasenews/activeannouncement', { loadingKey: LOADING_KEY })).then(storeActiveAnnouncement(dispatch));
    },

    acknowledge(id: string) {
        return (dispatch: AnyDispatch) =>
            dispatch(apiThunk<ActiveAnnouncement>(`/api/releasenews/acknowledge/${id}`, { loadingKey: LOADING_KEY, init: { method: 'POST' } })).then(
                storeActiveAnnouncement(dispatch)
            );
    },

    snooze(id: string) {
        return (dispatch: AnyDispatch) =>
            dispatch(apiThunk<ActiveAnnouncement>(`/api/releasenews/snooze/${id}`, { loadingKey: LOADING_KEY, init: { method: 'POST' } })).then(storeActiveAnnouncement(dispatch));
    },
};

export default releaseAnnouncementActions;
